var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('account-verification-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isWhiteLabeled = ref.isWhiteLabeled;
var contact = ref.contact;
var isLoading = ref.isLoading;
var sendVerificationEmail = ref.sendVerificationEmail;
var skipVerification = ref.skipVerification;
return [_c('account-verification-view',{attrs:{"is-white-labeled":isWhiteLabeled,"contact":contact,"is-loading":isLoading},on:{"send-verification-email":sendVerificationEmail,"skip-verification":skipVerification}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }